import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { CommentBoxModule } from '@portal-core/tasks/components/comment-box/comment-box.module';
import { TaskCommentComponent } from '@portal-core/tasks/components/task-comment/task-comment.component';

@NgModule({
  imports: [
    CommentBoxModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    LicenseUserAvatarModule
  ],
  declarations: [
    TaskCommentComponent
  ],
  exports: [
    TaskCommentComponent
  ]
})
export class TaskCommentModule { }
